/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Lot_Section_TitleInputs */

const vi_pos_lot_section_title = /** @type {(inputs: Pos_Lot_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô xuất kho`)
};

/**

* @param {Pos_Lot_Section_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_section_title = /** @type {((inputs?: Pos_Lot_Section_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_Section_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_section_title(inputs)
});